import e, { Component as t } from "react";
import i from "../../../utils/DomHandler.js";
import n from "../../../utils/ObjectUtils.js";
import r from "../../../utils/FilterUtils.js";
import o from "../../../../node_modules/classnames/index.js";
import { DropdownPanel as s } from "./DropdownPanel.js";
import { DropdownItem as l } from "./DropdownItem.js";
import { tip as a } from "../Tooltip/Tooltip.js";
import p from "../../../utils/UniqueComponentId.js";
import u from "../../../utils/ConnectedOverlayScrollHandler.js";
import { Icon as c } from "../../general/Icon/Icon.js";
import { Spinner as h } from "../../loaders/Spinner/Spinner.js";
import { FormLabel as d } from "../Label/FormLabel.js";
import { TAB as f, ESC as v, ENTER as m, SPACE as y, UP as b, DOWN as g } from "../../../constants/keyboard.js";
import { Tag as O } from "../../general/Tag/Tag.js";
import "../../general/Tag/RemovableTag.js";
import { t as k } from "../../../i18/index.js";
import I from "../../../../node_modules/react-transition-group/esm/CSSTransition.js";
function w(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var i = 0, n = Array(t); i < t; i++) n[i] = e[i];
  return n;
}
function C(e) {
  if (void 0 === e) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function E(e, t) {
  for (var i = 0; i < t.length; i++) {
    var n = t[i];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function L(e, t, i) {
  return t in e ? Object.defineProperty(e, t, {
    value: i,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = i, e;
}
function _(e) {
  return (_ = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function S(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = null != arguments[t] ? arguments[t] : {},
      n = Object.keys(i);
    "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(i).filter(function (e) {
      return Object.getOwnPropertyDescriptor(i, e).enumerable;
    }))), n.forEach(function (t) {
      L(e, t, i[t]);
    });
  }
  return e;
}
function x(e, t) {
  return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : function (e, t) {
    var i = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      i.push.apply(i, n);
    }
    return i;
  }(Object(t)).forEach(function (i) {
    Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(t, i));
  }), e;
}
function V(e, t) {
  return (V = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}
function j(e) {
  return function (e) {
    if (Array.isArray(e)) return w(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }(e) || function (e, t) {
    if (e) {
      if ("string" == typeof e) return w(e, t);
      var i = Object.prototype.toString.call(e).slice(8, -1);
      if ("Object" === i && e.constructor && (i = e.constructor.name), "Map" === i || "Set" === i) return Array.from(i);
      if ("Arguments" === i || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)) return w(e, t);
    }
  }(e) || function () {
    throw TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
var F = function (t) {
  !function (e, t) {
    if ("function" != typeof t && null !== t) throw TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && V(e, t);
  }(T, t);
  var w,
    F,
    D,
    P = (w = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }(), function () {
      var e,
        t,
        i = _(T);
      if (w) {
        var n = _(this).constructor;
        t = Reflect.construct(i, arguments, n);
      } else t = i.apply(this, arguments);
      return (e = t) && ("object" == (e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e) || "function" == typeof e) ? e : C(this);
    });
  function T() {
    var e;
    return !function (e, t) {
      if (!(e instanceof t)) throw TypeError("Cannot call a class as a function");
    }(this, T), e = P.apply(this, arguments), L(C(e), "id", e.props.id || p()), L(C(e), "trigger", void 0), L(C(e), "panel", void 0), L(C(e), "container", void 0), L(C(e), "nativeSelect", void 0), L(C(e), "focusInput", void 0), L(C(e), "input", void 0), L(C(e), "filterInput", void 0), L(C(e), "searchTimeout", void 0), L(C(e), "previousSearchChar", void 0), L(C(e), "currentSearchChar", void 0), L(C(e), "searchValue", void 0), L(C(e), "tooltip", void 0), L(C(e), "scrollHandler", void 0), L(C(e), "documentClickListener", void 0), L(C(e), "resizeListener", void 0), L(C(e), "chipsResizeObserver", void 0), L(C(e), "state", {
      filter: "",
      focused: !1,
      overlayVisible: !1,
      highlightedItemIndex: -1,
      shouldRenderTags: !0
    }), L(C(e), "onClick", function (t) {
      e.props.disabled || e.props.readOnly || e.isClearClicked(t) || (e.focusInput.focus(), e.state.overlayVisible ? e.hideOverlay() : e.showOverlay());
    }), L(C(e), "onInputFocus", function (t) {
      t.persist(), e.setState({
        focused: !0
      }, function () {
        e.props.onFocus && e.props.onFocus(t);
      }), e.props.showOnFocus && !e.state.overlayVisible && e.showOverlay();
    }), L(C(e), "onInputBlur", function (t) {
      t.persist(), e.setState({
        focused: !1,
        highlightedItemIndex: -1
      }, function () {
        e.props.onBlur && e.props.onBlur(t);
      });
    }), L(C(e), "onPanelClick", function (e) {
      e.stopPropagation();
    }), L(C(e), "onInputKeyDown", function (t) {
      switch (t.which) {
        case g:
          e.onDownKey(t);
          break;
        case b:
          e.onUpKey(t);
          break;
        case y:
          e.onMultipleSpaceOrEnter(t);
          break;
        case m:
          e.props.multiple ? e.onMultipleSpaceOrEnter(t) : (e.hideOverlay(), t.preventDefault());
          break;
        case v:
        case f:
          e.hideOverlay();
          break;
        default:
          e.search(t);
      }
    }), L(C(e), "onFilterInputKeyDown", function (t) {
      switch (t.which) {
        case g:
          e.onDownKey(t);
          break;
        case b:
          e.onUpKey(t);
          break;
        case m:
        case v:
          e.hideOverlay(), t.preventDefault();
      }
    }), L(C(e), "onUpKey", function (t) {
      if (e.props.options && !e.props.multiple) {
        var i = e.getVisibleOptions(),
          n = e.findOptionIndex(e.props.value, i),
          r = e.findPrevVisibleItem(n, i);
        r && e.selectItem({
          originalEvent: t,
          option: r
        });
      }
      e.props.multiple && e.setState(function (e) {
        return x(S({}, e), {
          highlightedItemIndex: e.highlightedItemIndex - 1
        });
      }), t.preventDefault();
    }), L(C(e), "onDownKey", function (t) {
      if (e.props.options && !e.props.multiple) {
        if (!e.state.overlayVisible && t.altKey) e.showOverlay();else {
          var i = e.getVisibleOptions(),
            n = e.findOptionIndex(e.props.value, i),
            r = e.findNextVisibleItem(n, i);
          r && e.selectItem({
            originalEvent: t,
            option: r
          });
        }
      }
      e.props.multiple && e.setState(function (e) {
        return x(S({}, e), {
          highlightedItemIndex: e.highlightedItemIndex + 1
        });
      }), t.preventDefault();
    }), L(C(e), "onEditableInputClick", function (t) {
      e.bindDocumentClickListener(), t.stopPropagation();
    }), L(C(e), "onEditableInputChange", function (t) {
      e.props.onChange({
        originalEvent: t,
        value: t.target.value,
        target: {
          name: e.props.name,
          id: e.id,
          value: t.target.value
        }
      });
    }), L(C(e), "onEditableInputFocus", function (t) {
      t.persist(), e.setState({
        focused: !0
      }, function () {
        e.hideOverlay(), e.props.onFocus && e.props.onFocus(t);
      });
    }), L(C(e), "onOptionClick", function (t) {
      var i = t.option;
      n.isObjectAndContainsKey(i, "disabled") && i.disabled || (e.selectItem(t), e.focusInput.focus()), e.props.multiple || e.hideOverlay();
    }), L(C(e), "onFilterInputChange", function (t) {
      e.setState({
        filter: t.target.value
      });
    }), L(C(e), "clear", function (t) {
      e.props.onChange({
        originalEvent: t,
        value: e.props.multiple ? [] : null,
        target: {
          name: e.props.name,
          id: e.id,
          value: e.props.multiple ? [] : null
        }
      }), e.updateEditableLabel();
    }), L(C(e), "onOverlayEnter", function () {
      e.panel.element.style.zIndex = String(i.generateZIndex()), e.alignPanel();
    }), L(C(e), "onOverlayEntered", function () {
      e.scrollInView(), e.bindDocumentClickListener(), e.bindScrollListener(), e.bindResizeListener(), e.props.filter && e.props.filterInputAutoFocus && e.filterInput.focus();
    }), L(C(e), "onOverlayExit", function () {
      e.unbindDocumentClickListener(), e.unbindScrollListener(), e.unbindResizeListener();
    }), L(C(e), "onOverlayExited", function () {
      e.props.filter && e.props.resetFilterOnHide && e.resetFilter();
    }), L(C(e), "clearChips", function (t) {
      t.stopPropagation(), e.clear(t);
    }), e;
  }
  return F = [{
    key: "onMultipleSpaceOrEnter",
    value: function value(e) {
      if (this.state.overlayVisible) {
        if (this.props.multiple && this.state.highlightedItemIndex >= 0) {
          var t = this.getVisibleOptions()[this.state.highlightedItemIndex],
            i = this.getOptionValue(t);
          this.selectItem({
            originalEvent: e,
            option: t,
            selected: !this.props.value.some(function (e) {
              return e === i;
            })
          });
        }
      } else this.showOverlay();
      e.preventDefault();
    }
  }, {
    key: "search",
    value: function value(e) {
      var t = this;
      this.searchTimeout && clearTimeout(this.searchTimeout);
      var i = String.fromCharCode(e.keyCode);
      this.previousSearchChar = this.currentSearchChar, this.currentSearchChar = i, this.previousSearchChar === this.currentSearchChar ? this.searchValue = this.currentSearchChar : this.searchValue = this.searchValue ? this.searchValue + i : i;
      var n = this.props.value && !this.props.multiple ? this.findOptionIndex(this.props.value, this.props.options) : -1,
        r = this.searchOption(++n);
      r && (this.props.multiple ? this.setState({
        highlightedItemIndex: this.props.options.indexOf(r)
      }) : this.selectItem({
        originalEvent: e,
        option: r
      })), this.searchTimeout = setTimeout(function () {
        t.searchValue = null;
      }, 250);
    }
  }, {
    key: "searchOption",
    value: function value(e) {
      var t;
      return !this.searchValue || (t = this.searchOptionInRange(e, this.props.options.length)) || (t = this.searchOptionInRange(0, e)), t;
    }
  }, {
    key: "searchOptionInRange",
    value: function value(e, t) {
      for (var i = e; i < t; i++) {
        var n = this.props.options[i];
        if (this.getOptionLabel(n).toString().toLocaleLowerCase(this.props.filterLocale).startsWith(this.searchValue.toLocaleLowerCase(this.props.filterLocale))) return n;
      }
      return null;
    }
  }, {
    key: "filter",
    value: function value(e) {
      var t = this.state.filter.trim().toLocaleLowerCase(this.props.filterLocale),
        i = this.props.filterBy ? this.props.filterBy.split(",") : [this.props.optionLabel || "label"],
        n = r.filter(e, i, t, this.props.filterMatchMode, this.props.filterLocale);
      return n && n.length ? n : null;
    }
  }, {
    key: "findNextVisibleItem",
    value: function value(e, t) {
      var i = e + 1;
      if (i === t.length) return null;
      var r = t[i];
      return n.isObjectAndContainsKey(r, "disabled") && r.disabled ? this.findNextVisibleItem(i) : r;
    }
  }, {
    key: "findPrevVisibleItem",
    value: function value(e, t) {
      var i = e - 1;
      if (i < 0) return null;
      var r = t[i];
      return n.isObjectAndContainsKey(r, "disabled") && r.disabled ? this.findPrevVisibleItem(i) : r;
    }
  }, {
    key: "resetFilter",
    value: function value() {
      this.setState({
        filter: ""
      });
    }
  }, {
    key: "selectItem",
    value: function value(e) {
      var t = this.findOption(this.props.value),
        i = this.getOptionValue(e.option);
      if (this.props.multiple) {
        var n,
          r = j(null !== (n = this.props.value) && void 0 !== n ? n : []);
        if (e.selected) r.push(i);else {
          var o = r.findIndex(function (e) {
            return e === i;
          });
          o > -1 && r.splice(o, 1);
        }
        this.props.onChange({
          originalEvent: e.originalEvent,
          value: r,
          target: {
            name: this.props.name,
            id: this.id,
            value: r
          }
        });
      } else t !== e.option && (this.updateEditableLabel(e.option), this.props.onChange({
        originalEvent: e.originalEvent,
        value: i,
        target: {
          name: this.props.name,
          id: this.id,
          value: i
        }
      }));
    }
  }, {
    key: "findOptionIndex",
    value: function value(e, t) {
      var i = -1;
      if (t) for (var r = 0; r < t.length; r++) {
        var o = this.getOptionValue(t[r]);
        if (null === e && null == o || n.equals(e, o, this.props.dataKey)) {
          i = r;
          break;
        }
      }
      return i;
    }
  }, {
    key: "findOptionIndexes",
    value: function value(e, t) {
      var i = this;
      return e.map(function (e) {
        return i.findOptionIndex(e, t);
      });
    }
  }, {
    key: "findOption",
    value: function value(e) {
      var t = this;
      if (null == e) return null;
      var i = this.props.multiple ? this.findOptionIndexes(e, this.props.options) : this.findOptionIndex(e, this.props.options);
      return "number" == typeof i && -1 !== i ? this.props.options[i] : i instanceof Array ? i.map(function (e) {
        return -1 !== e ? t.props.options[e] : null;
      }) : null;
    }
  }, {
    key: "showOverlay",
    value: function value() {
      this.setState({
        overlayVisible: !0
      });
    }
  }, {
    key: "hideOverlay",
    value: function value() {
      this.setState({
        overlayVisible: !1
      });
    }
  }, {
    key: "alignPanel",
    value: function value() {
      var e = this.input.parentElement;
      this.props.appendTo ? (this.panel.element.style.width = e.offsetWidth + "px", i.absolutePosition(this.panel.element, e)) : i.relativePosition(this.panel.element, e), this.moveVertically(this.panel.element.style);
    }
  }, {
    key: "moveVertically",
    value: function value(e) {
      var t = e.transformOrigin.includes("top");
      e.transform = t ? "translateY(4px)" : "translateY(-4px)";
    }
  }, {
    key: "scrollInView",
    value: function value() {
      var e = this.props.multiple && Array.isArray(this.props.value) ? this.props.value[this.props.value.length - 1] : this.props.value,
        t = i.findSingle(this.panel.element, "li.dropdown__item--highlight[data-value='".concat(e, "']"));
      t && i.scrollInView(this.panel.itemsWrapper, t);
    }
  }, {
    key: "bindDocumentClickListener",
    value: function value() {
      var e = this;
      this.documentClickListener || (this.documentClickListener = function (t) {
        e.state.overlayVisible && e.isOutsideClicked(t) && e.hideOverlay();
      }, document.addEventListener("click", this.documentClickListener));
    }
  }, {
    key: "unbindDocumentClickListener",
    value: function value() {
      this.documentClickListener && (document.removeEventListener("click", this.documentClickListener), this.documentClickListener = null);
    }
  }, {
    key: "bindScrollListener",
    value: function value() {
      var e = this;
      this.scrollHandler || (this.scrollHandler = new u(this.container, function () {
        e.state.overlayVisible && e.hideOverlay();
      })), this.scrollHandler.bindScrollListener();
    }
  }, {
    key: "unbindScrollListener",
    value: function value() {
      this.scrollHandler && this.scrollHandler.unbindScrollListener();
    }
  }, {
    key: "bindResizeListener",
    value: function value() {
      var e = this;
      this.resizeListener || (this.resizeListener = function () {
        e.state.overlayVisible && e.hideOverlay();
      }, window.addEventListener("resize", this.resizeListener));
    }
  }, {
    key: "unbindResizeListener",
    value: function value() {
      this.resizeListener && (window.removeEventListener("resize", this.resizeListener), this.resizeListener = null);
    }
  }, {
    key: "isOutsideClicked",
    value: function value(e) {
      var t = e.target;
      return this.container && !(this.container.isSameNode(t) || this.isClearClicked(e) || this.container.contains(t) || this.panel && this.panel.element && this.panel.element.contains(t));
    }
  }, {
    key: "isClearClicked",
    value: function value(e) {
      return i.hasClass(e.target, "kaseya-ui-dropdown__clear-icon");
    }
  }, {
    key: "updateEditableLabel",
    value: function value(e) {
      if (this.input && !this.props.multiple) {
        var t;
        this.input.value = e ? this.getOptionLabel(e) : (null === (t = this.props.value) || void 0 === t ? void 0 : t.toString()) || "";
      }
    }
  }, {
    key: "hasFilter",
    value: function value() {
      return this.state.filter && this.state.filter.trim().length > 0;
    }
  }, {
    key: "getOptionLabel",
    value: function value(e) {
      return this.props.optionLabel ? n.resolveFieldData(e, this.props.optionLabel) : "object" == typeof e && "label" in e ? e.label : e;
    }
  }, {
    key: "getOptionValue",
    value: function value(e) {
      return this.props.optionValue ? n.resolveFieldData(e, this.props.optionValue) : "object" == typeof e && "value" in e ? e.value : e;
    }
  }, {
    key: "getOptionKey",
    value: function value(e, t) {
      return this.props.dataKey ? n.resolveFieldData(e, this.props.dataKey) : "pr_id__".concat(this.getOptionLabel(e), "-").concat(t);
    }
  }, {
    key: "checkValidity",
    value: function value() {
      return this.nativeSelect.checkValidity();
    }
  }, {
    key: "getVisibleOptions",
    value: function value() {
      return this.props.options && this.hasFilter() ? this.filter(this.props.options) : this.props.options;
    }
  }, {
    key: "updateInputField",
    value: function value() {
      if (this.props.editable && this.input) {
        var e = this.findOption(this.props.value),
          t = (e ? this.getOptionLabel(e) : null) || this.props.value || "";
        this.input.value = t;
      }
    }
  }, {
    key: "componentDidMount",
    value: function value() {
      var e = this;
      this.props.autoFocus && this.focusInput && this.focusInput.focus(), this.props.tooltip && this.renderTooltip(), this.props.multiple && this.input && (this.chipsResizeObserver = new ResizeObserver(function () {
        e.input.scrollWidth <= e.input.clientWidth ? e.setState({
          shouldRenderTags: !0
        }) : e.setState({
          shouldRenderTags: !1
        });
      }), this.chipsResizeObserver.observe(this.input)), this.updateInputField(), this.nativeSelect.selectedIndex = 1;
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      this.unbindDocumentClickListener(), this.unbindResizeListener(), this.scrollHandler && (this.scrollHandler.destroy(), this.scrollHandler = null), this.tooltip && (this.tooltip.destroy(), this.tooltip = null), this.chipsResizeObserver && this.input && (this.chipsResizeObserver.unobserve(this.input), this.chipsResizeObserver = void 0);
    }
  }, {
    key: "componentDidUpdate",
    value: function value(e, t) {
      this.state.overlayVisible && (this.props.filter && this.alignPanel(), e.value !== this.props.value && this.scrollInView()), e.tooltip !== this.props.tooltip && (this.tooltip ? this.tooltip.updateContent(this.props.tooltip) : this.renderTooltip()), this.state.filter && (!this.props.options || 0 === this.props.options.length) && this.setState({
        filter: ""
      }), this.state.shouldRenderTags && this.input.scrollWidth > this.input.clientWidth ? this.setState({
        shouldRenderTags: !1
      }) : this.state.shouldRenderTags || t.shouldRenderTags || this.setState({
        shouldRenderTags: !0
      }), this.updateInputField(), this.nativeSelect.selectedIndex = 1;
    }
  }, {
    key: "renderHiddenSelect",
    value: function value(t) {
      var i,
        r = this,
        o = e.createElement("option", {
          value: ""
        }, this.props.placeholder),
        s = t ? t instanceof Array ? t.map(function (t, i) {
          var n;
          return e.createElement("option", {
            key: r.getOptionKey(t, i),
            value: null === (n = r.getOptionValue(t)) || void 0 === n ? void 0 : n.toString()
          }, r.getOptionLabel(t));
        }) : e.createElement("option", {
          value: n.isObjectAndContainsKey(t, "value") ? null === (i = t.value) || void 0 === i ? void 0 : i.toString() : t.toString()
        }, this.getOptionLabel(t)) : null;
      return e.createElement("div", {
        className: "dropdown-hidden-accessible"
      }, e.createElement("select", {
        ref: function ref(e) {
          return r.nativeSelect = e;
        },
        required: this.props.required,
        name: this.props.name,
        tabIndex: -1,
        "aria-hidden": "true"
      }, o, s));
    }
  }, {
    key: "renderTooltip",
    value: function value() {
      this.tooltip = a({
        target: this.container,
        content: this.props.tooltip,
        options: this.props.tooltipOptions
      });
    }
  }, {
    key: "renderKeyboardHelper",
    value: function value() {
      var t = this;
      return e.createElement("div", {
        className: "dropdown-hidden-accessible"
      }, e.createElement("input", {
        ref: function ref(e) {
          return t.focusInput = e;
        },
        id: this.props.inputId || this.props.name,
        type: "text",
        readOnly: !0,
        "aria-haspopup": "listbox",
        onFocus: this.onInputFocus,
        onBlur: this.onInputBlur,
        onKeyDown: this.onInputKeyDown,
        disabled: this.props.disabled,
        tabIndex: this.props.tabIndex,
        "aria-label": this.props.ariaLabel,
        "aria-labelledby": this.props.ariaLabelledBy
      }));
    }
  }, {
    key: "renderLabel",
    value: function value(t) {
      var i = this,
        r = n.isNil(t) || t instanceof Array ? null : this.getOptionLabel(t);
      if (this.props.editable) {
        var s = r || this.props.value || "";
        return e.createElement("input", {
          ref: function ref(e) {
            return i.input = e;
          },
          type: "text",
          defaultValue: null == s ? void 0 : s.toString(),
          className: "dropdown__label",
          disabled: this.props.disabled,
          placeholder: this.props.placeholder,
          maxLength: this.props.maxLength,
          onClick: this.onEditableInputClick,
          onInput: this.onEditableInputChange,
          onFocus: this.onEditableInputFocus,
          onBlur: this.onInputBlur,
          "aria-label": this.props.ariaLabel,
          "aria-labelledby": this.props.ariaLabelledBy,
          "aria-haspopup": "listbox"
        });
      }
      var l,
        a = null !== r || Array.isArray(t) && t.length > 0,
        p = o("dropdown__label", {
          dropdown__placeholder: !a && this.props.placeholder,
          "dropdown__label--empty": !a && !this.props.placeholder,
          "dropdown__label--multiple": this.props.multiple
        }),
        u = this.props.valueTemplate ? n.getJSXElement(this.props.valueTemplate, t, this.props) : this.props.multiple && t ? this.renderChips(t) : null !== (l = null != r ? r : this.props.placeholder) && void 0 !== l ? l : "empty";
      return e.createElement("span", {
        ref: function ref(e) {
          return i.input = e;
        },
        className: p
      }, u);
    }
  }, {
    key: "renderChips",
    value: function value(t) {
      var i,
        n = this;
      return this.state.shouldRenderTags ? 0 === t.length ? null !== (i = this.props.placeholder) && void 0 !== i ? i : "empty" : t.map(function (t, i) {
        var r = n.getOptionLabel(t),
          o = n.getOptionValue(t),
          s = n.getOptionKey(t, i);
        return e.createElement(O, {
          className: "dropdown__label-tag",
          key: s
        }, e.createElement("div", {
          className: "dropdown__label-tag-text"
        }, r), e.createElement(c, {
          regular: !0,
          name: "close",
          className: "dropdown__label-tag-close",
          onClick: function onClick(e) {
            return n.handleChipDelete(o, e);
          }
        }));
      }) : e.createElement(O, {
        className: "dropdown__label-tag"
      }, e.createElement("div", {
        className: "dropdown__label-tag-text"
      }, k("selected", {
        count: t.length
      })), e.createElement(c, {
        regular: !0,
        name: "close",
        className: "dropdown__label-tag-close",
        onClick: this.clearChips
      }));
    }
  }, {
    key: "handleChipDelete",
    value: function value(e, t) {
      var i = j(this.props.value),
        n = i.findIndex(function (t) {
          return t === e;
        });
      n > -1 && i.splice(n, 1), t.stopPropagation(), this.props.onChange({
        originalEvent: t,
        value: i,
        target: {
          name: this.props.name,
          id: this.id,
          value: i
        }
      });
    }
  }, {
    key: "renderClearIcon",
    value: function value() {
      return null != this.props.value && this.props.showClear && !this.props.disabled ? e.createElement(c, {
        regular: !0,
        name: "times",
        className: "dropdown__clear-icon",
        onClick: this.clear
      }) : null;
    }
  }, {
    key: "renderDropdownIcon",
    value: function value() {
      var t = this;
      return e.createElement("div", {
        ref: function ref(e) {
          return t.trigger = e;
        },
        className: "dropdown__trigger",
        role: "button",
        "aria-haspopup": "listbox",
        "aria-expanded": this.state.overlayVisible
      }, e.createElement(c, {
        regular: !0,
        name: "angle-down",
        className: o("dropdown__trigger-icon", this.props.disabled && "dropdown__trigger-icon--disabled", this.props.readOnly && "dropdown__trigger-icon--readonly")
      }));
    }
  }, {
    key: "renderItems",
    value: function value(t) {
      var i = this,
        r = this.getVisibleOptions();
      if (r && r.length) return r.map(function (r, o) {
        var s = i.getOptionLabel(r),
          a = i.getOptionValue(r),
          p = i.getOptionKey(r, o);
        return e.createElement(l, {
          key: p,
          label: s,
          value: a,
          option: r,
          template: i.props.itemTemplate,
          selected: t instanceof Array ? t.includes(r) : t === r,
          disabled: n.isObjectAndContainsKey(r, "disabled") && r.disabled,
          onClick: i.onOptionClick,
          showCheckbox: i.props.multiple,
          highlighted: i.state.highlightedItemIndex === o
        });
      });
      if (this.hasFilter()) {
        var o = n.getJSXElement(this.props.emptyFilterMessage, this.props);
        return e.createElement("li", {
          className: "kaseya-ui-dropdown__items--empty-message"
        }, o);
      }
      return null;
    }
  }, {
    key: "renderFilter",
    value: function value() {
      var t = this;
      return this.props.filter ? e.createElement("div", {
        className: "dropdown__filter__container"
      }, e.createElement("input", {
        ref: function ref(e) {
          return t.filterInput = e;
        },
        type: "text",
        autoComplete: "off",
        className: "dropdown__filter",
        placeholder: this.props.filterPlaceholder,
        onKeyDown: this.onFilterInputKeyDown,
        onChange: this.onFilterInputChange,
        value: this.state.filter
      }), e.createElement(c, {
        regular: !0,
        name: "search",
        className: "dropdown__filter__icon"
      })) : null;
    }
  }, {
    key: "renderLoader",
    value: function value() {
      return this.props.loading ? e.createElement(h, {
        className: "dropdown__spinner"
      }) : null;
    }
  }, {
    key: "renderFieldLabel",
    value: function value() {
      return e.createElement(d, {
        value: this.props.label,
        isRequired: this.props.required
      });
    }
  }, {
    key: "renderErrorMessage",
    value: function value() {
      return e.createElement("div", {
        className: "error-msg"
      }, this.props.errorMessage);
    }
  }, {
    key: "render",
    value: function value() {
      var t,
        i,
        r = this,
        l = o("kaseya-ui-dropdown", this.props.className),
        a = this.findOption(this.props.value),
        p = o("dropdown__wrapper", {
          "dropdown__wrapper--disabled": this.props.disabled,
          "dropdown__wrapper--error": this.props.errorMessage,
          "dropdown__wrapper--readonly": this.props.readOnly,
          "dropdown__wrapper--has-label-tags": this.props.multiple && !n.isNil(a) && a.length > 0
        }),
        u = this.renderHiddenSelect(a),
        c = this.renderKeyboardHelper(),
        h = this.renderLabel(a),
        d = this.renderDropdownIcon(),
        f = this.renderItems(a),
        v = this.renderFilter(),
        m = this.renderClearIcon(),
        y = this.renderLoader();
      return this.props.label && (t = this.renderFieldLabel()), this.props.errorMessage && (i = this.renderErrorMessage()), e.createElement("div", x(S({}, this.props.containerAttributes), {
        id: this.id,
        className: l,
        style: this.props.style
      }), t, e.createElement("div", {
        ref: function ref(e) {
          return r.container = e;
        },
        className: p,
        onClick: this.onClick,
        onMouseDown: this.props.onMouseDown,
        onContextMenu: this.props.onContextMenu
      }, c, u, h, y, m, d, e.createElement(I, {
        classNames: "dropdown__connected-overlay",
        in: this.state.overlayVisible,
        timeout: {
          enter: 120,
          exit: 100
        },
        unmountOnExit: !0,
        onEnter: this.onOverlayEnter,
        onEntered: this.onOverlayEntered,
        onExit: this.onOverlayExit,
        onExited: this.onOverlayExited
      }, e.createElement(s, x(S({}, this.props.panelContainerAttributes), {
        ref: function ref(e) {
          return r.panel = e;
        },
        appendTo: this.props.appendTo,
        panelStyle: this.props.panelStyle,
        panelClassName: this.props.panelClassName,
        scrollHeight: this.props.scrollHeight,
        filter: v,
        onClick: this.onPanelClick,
        footer: this.props.footer
      }), f))), i);
    }
  }], E(T.prototype, F), D && E(T, D), T;
}(t);
L(F, "defaultProps", {
  scrollHeight: "200px",
  filter: !1,
  filterMatchMode: "contains",
  emptyFilterMessage: "No results found",
  editable: !1,
  required: !1,
  disabled: !1,
  autoFocus: !1,
  filterInputAutoFocus: !0,
  resetFilterOnHide: !1,
  showClear: !1,
  loading: !1,
  showOnFocus: !1,
  readOnly: !1,
  multiple: !1
});
export { F as Dropdown };